import React, { useState, useEffect, useRef } from "react";
import useStyles from "./styles";
import LoadingIcon from "../../assets/img/icons/loaderIcon.gif";
import LoadingIconFiggers from "../../assets/img/icons/loaderfiggers.gif";

export default function DialogLoader({nobg, ...props}) {
    const classes = useStyles();
    return (
        <>
            <div className={nobg? classes.dialogloaderNoBg : classes.dialogloader}>
                <img src={LoadingIconFiggers} />
            </div>
        </>
    )
}
